import React from 'react';
import './OverviewScreen.css';

export default function OverviewScreen({ userEmail, firstName }) {
  // Use firstName from profile; fallback to email prefix
  const rawName = (firstName && firstName.trim()) || (userEmail ? userEmail.split('@')[0] : null) || 'User';
  const userName = rawName ? rawName.charAt(0).toUpperCase() + rawName.slice(1).toLowerCase() : 'User';

  return (
    <>
      <div className="vt-pageHead">
        <h1 className="vt-pageTitle" style={{ fontSize: '3rem', fontWeight: '700', marginBottom: '1rem' }}>
          Welcome, {userName}
        </h1>
      </div>
    </>
  );
}
